<template>
  <fragment>
    <template v-if="mdAndUp">
      <v-carousel
        light
        hide-delimiters
        height="230"
        dark
        touchless
        show-arrows-on-hover
        v-if="sizeActiveEvents.length > 0"
      >
        <template v-slot:prev="{ on, attrs }">
          <v-btn fab v-bind="attrs" v-on="on" small color="#572c88">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <template v-slot:next="{ on, attrs }">
          <v-btn fab v-bind="attrs" v-on="on" small color="#572c88">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <v-carousel-item
          v-for="(events, index) in sizeActiveEvents"
          :key="index"
        >
          <div class="slide">
            <ResumeCard
              v-for="(evento, i) in events"
              :key="i"
              :evento="evento"
              :closed="false"
            >
              <v-btn text color="primary" v-if="i == 3">See More</v-btn>
            </ResumeCard>
            <v-row>
              <v-col align="start" class="mt-6">
                <v-btn
                  class="mt-16 rounded-xl"
                  color="#572c88"
                  dark
                  v-if="index != 4"
                  @click="loadItems"
                  :loading="$dashboard.loadingMore"
                  ><v-icon>mdi-plus</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-carousel-item>
      </v-carousel>
      <v-carousel
        light
        hide-delimiters
        height="230"
        touchless
        dark
        show-arrows-on-hover
        v-if="sizeInactiveEvents.length > 0"
      >
        <template v-slot:prev="{ on, attrs }">
          <v-btn fab v-bind="attrs" v-on="on" small color="#572c88">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <template v-slot:next="{ on, attrs }">
          <v-btn fab v-bind="attrs" v-on="on" small color="#572c88">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <v-carousel-item
          v-for="(events, index) in sizeInactiveEvents"
          :key="index"
        >
          <div class="slide">
            <ResumeCard
              v-for="(evento, i) in events"
              :key="i"
              :evento="evento"
              :closed="true"
            >
            </ResumeCard>
            <v-row>
              <v-col align="start" class="mt-6">
                <v-btn
                  class="mt-16 rounded-xl"
                  color="#572c88"
                  v-if="index != 4"
                  @click="loadItems"
                  :loading="$dashboard.loadingMore"
                  ><v-icon color="#fff">mdi-plus</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-carousel-item>
      </v-carousel>
    </template>
    <template v-else>
      <v-carousel
        light
        hide-delimiters
        height="230"
        dark
        v-if="sizeActiveEvents.length > 0"
      >
        <template v-slot:prev="{ on, attrs }">
          <v-btn fab v-bind="attrs" v-on="on" small color="#572c88">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <template v-slot:next="{ on, attrs }">
          <v-btn fab v-bind="attrs" v-on="on" small color="#572c88">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <v-carousel-item
          v-for="(events, index) in sizeActiveEvents"
          :key="index"
        >
          <div class="slide">
            <ResumeCard
              v-for="(evento, i) in events"
              :key="i"
              :evento="evento"
              :closed="false"
            >
              <v-btn text color="primary" v-if="i == 3">See More</v-btn>
            </ResumeCard>
            <v-row>
              <v-col align="start" class="mt-6">
                <v-btn
                  class="mt-16 rounded-xl"
                  color="#572c88"
                  v-if="index != 4"
                  @click="loadItems"
                  :loading="$dashboard.loadingMore"
                  ><v-icon color="#fff">mdi-plus</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-carousel-item>
      </v-carousel>
      <v-carousel
        light
        hide-delimiters
        height="230"
        dark
        v-if="sizeInactiveEvents.length > 0"
      >
        <template v-slot:prev="{ on, attrs }">
          <v-btn fab v-bind="attrs" v-on="on" small color="#572c88">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <template v-slot:next="{ on, attrs }">
          <v-btn fab v-bind="attrs" v-on="on" small color="#572c88">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <v-carousel-item
          v-for="(events, index) in sizeInactiveEvents"
          :key="index"
        >
          <div class="slide">
            <ResumeCard
              v-for="(evento, i) in events"
              :key="i"
              :evento="evento"
              :closed="true"
            >
            </ResumeCard>
            <v-row>
              <v-col align="start" class="mt-6">
                <v-btn
                  class="mt-16 rounded-xl"
                  color="#572c88"
                  v-if="index != 4"
                  @click="loadItems()"
                  :loading="$dashboard.loadingMore"
                  ><v-icon color="#fff">mdi-plus</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-carousel-item>
      </v-carousel>
    </template>
  </fragment>
</template>

<script>
import ResumeCard from "@/components/cards/ResumeCardModal.vue";
import displayHelpers from "@/mixins/breakpoints.mixins";
export default {
  name: "EventSlider",
  mixins: [displayHelpers],
  components: {
    ResumeCard,
  },
  data() {
    return {
      page: 10,
    };
  },
  computed: {
    sizeActiveEvents() {
      const sizeCont = 4;
      const activeEvents = this.$dashboard.eventosAtivos.slice(0, 30);
      const sizeEvents = [];
      for (let i = 0; i < activeEvents.length; i += sizeCont) {
        sizeEvents.push(activeEvents.slice(i, i + sizeCont));
      }
      return sizeEvents.slice(0, 3);
    },
    sizeInactiveEvents() {
      const sizeCont = 4;
      const inactiveEvents = this.$dashboard.eventosEncerrados.slice(0, 20);
      const sizeEvents = [];
      for (let i = 0; i < inactiveEvents.length; i += sizeCont) {
        sizeEvents.push(inactiveEvents.slice(i, i + sizeCont));
      }
      return sizeEvents.slice(0, 3);
    },
    sizeActiveEventsMobile() {
      const sizeContMobile = 1;
      const activeEventsMobile = this.$dashboard.eventosAtivos.slice(0, 10);
      const sizeEventsMobile = [];
      for (let i = 0; i < activeEventsMobile.length; i += sizeContMobile) {
        sizeEventsMobile.push(activeEventsMobile.slice(i, i + sizeContMobile));
      }
      return sizeEventsMobile.slice(0, 3);
    },
    sizeInactiveEventsMobile() {
      const sizeContMobile = 1;
      const inactiveEventsMobile = this.$dashboard.eventosEncerrados.slice(
        0,
        10
      );
      const sizeEventsMobile = [];
      for (let i = 0; i < inactiveEventsMobile.length; i += sizeContMobile) {
        sizeEventsMobile.push(
          inactiveEventsMobile.slice(i, i + sizeContMobile)
        );
      }
      return sizeEventsMobile.slice(0, 3);
    },
  },
  methods: {
    loadItems() {
      this.$store.commit("setIsOpenModal", false);
    },
  },
};
</script>

<style scoped>
.slide {
  display: flex;
  justify-content: flex-start;
}
</style>
